import React, {useEffect, useState} from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography, Divider, TextField, InputAdornment, DialogActions
} from '@mui/material';
import AddBox from '@mui/icons-material/AddBox';
import CloseIcon from '@mui/icons-material/Close';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {EditOutlined} from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import {useSnackbar} from "notistack";
import LoadingButton from "../../../../components/elements/LoadingButton";
import validator from "validator";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import AppCardLoaderFields from "../../../../components/loaders/AppCardLoaderFields";
import RayaField from "../../../../components/elements/fields/RayaField";
import {Pencil} from "lucide-react";

const MakeMenuButton = ({ disabled, classes,item_id,shop_id,reload,onMenuCreated,variant,color }) => {
    const [open, setOpen] = useState(false);
    const navigation = useNavigate();
    const { t } = useTranslation();

    const initFields = {
        name: '',
    };
    const [fields, setFields] = useState(initFields);
    const [errors, setErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const loginToken = localStorage.getItem('ACT');
    const loadData = async () =>{
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        }
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/menus/get/${item_id}`,config)
            .then(response => {
                let fields = {
                    name: response.data.name,
                }
                setFields(fields);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                navigation('/');
                setLoading(false); // Set loading to false even if there is an error
            });
    }

    useEffect(() => {
        if(!!item_id && !!open)  loadData();
    }, [item_id,open]);

    useEffect(() => {

    }, [shop_id]);
    
    const handleChange = (e) => {
        let { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const resetFields = () => setFields(initFields);
    const closeDialog = () => {
        setOpen(false);
        if(!item_id){
            setTimeout(() => {
                resetFields();
            }, 300);
        }

    }
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};

        // Validation for full_name
        if (validator.isEmpty(fields.name)) {
            formIsValid = false;
            newErrors.name = t('emptyField');
        }

        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();
        data.append('name', fields.name);
        data.append('description', fields.description);

        if(!!item_id){
            data.append('item_id', item_id);
        }
        if(!!shop_id){
            data.append('shop_id', shop_id);
        }

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/menus/make`, data, config);
            if(typeof onMenuCreated === "function"){
                onMenuCreated(response.data)
            }else{
                reload();
            }

            setSubmitLoading(false);
            closeDialog();

        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            if(error.response.status === 403){
                enqueueSnackbar(t('duplicateItemName'), { variant: 'warning' });
            }else{
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });

            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };
    return (
        <>
            {
                !!item_id ?
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => setOpen(!open)}
                        startIcon={ <Pencil className="lucide-icon-secondary btn"/>}
                    >
                        {t("edit")}
                    </Button>
                    :
                    <Button
                        disabled={disabled}
                        variant={!!item_id ? "contained" : !!variant ? variant : "outlined"}
                        color={!!color ? color : "primary"}
                        size="small"
                        startIcon={!!item_id ? <EditOutlined/> : <AddBox/>}
                        onClick={() => setOpen(!open)}
                    >
                        {t(!!item_id ? "editMenu" : 'addMenu')}
                    </Button>
            }
            <Dialog
                fullWidth
                maxWidth={'xs'}
                open={open}
                onClose={() => closeDialog()}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    {t(!!item_id ? "editMenu" : 'addMenu')}
                    <IconButton aria-label="close" className={classes.dialogClose} onClick={() => closeDialog()}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <Divider/>
                <DialogContent className="dialog-add-match">
                    <Grid container spacing={2}>
                        {
                            !!loading ?
                                <Grid item size={12}>
                                    <AppCardLoaderFields/>
                                </Grid>
                                    :
                                <>
                                    <Grid item size={{xs: 12}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('menuName')}
                                            name="name"
                                            value={fields.name}
                                            onChange={handleChange}
                                            error={!!errors.name}
                                            helperText={errors.name}
                                            inputProps={{ maxLength: 30 }}
                                        />
                                    </Grid>
                                </>
                        }

                    </Grid>
                </DialogContent>
                <DialogActions style={{display:"flex",justifyContent:"center"}}>
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            loading={submitLoading}
                        >
                            {t('setDetails')}
                        </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default withStyles(Styles)(MakeMenuButton);
